import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { CardType } from '../../Prototype/Level/Card/CardType';
import { ICardModifierData } from '../../Prototype/Level/Card/ICardModifierData';
import { IGameState } from '../Game/IGameState';
import { hidePopup } from '../UI/UIStateHelper';
import { CardActions } from './CardActions';
import CardStateHelper, { setNewTurnCardState } from './CardStateHelper';
import { CardTask } from './CardTasks';

export interface ICardStateData {
    id: string;
    type: CardType;
    random: boolean;
    value: number;
    suit?: number;
    depth: number;
    faceUp: boolean;
    sequence: number;
    modifiers: ICardModifierData[];
    x: number;
    y: number;
    rotation: number;
    width?: number;
    height?: number;
    attempts: number; // Number of attempts to play the card.
}

/**
 * Card action data used to trigger state animations.
 */
export interface ICardStateTaskData {
    task: CardTask;
    cards: string[];
    [key: string]: any;
}

export interface ICardStateMap {
    [id: string]: ICardStateData;
}

export interface ICardsState {
    cards: ICardStateMap;
    inPlay: string[];
    inStack: string[];
    folded: string[];
    discarded: string[];
    turns: number;
    tasks: ICardStateTaskData[];
    turnScore: number;
    undoHistory: any[];
    streakSequence: number;
    streakScore: number;

    /**
     * Temp fix to control streak functionality at the card-state level because it would be too much work to
     * elevate cardState to levelState in all of CardStateHelper.
     * TODO: Elevate cardState data to levelState.
     */
    streakEnabled: boolean;
    streakCards: number;
}

export const cardReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof CardActions>
): IGameState => {
    state = setNewTurnCardState(state);

    switch (action.type) {
        case getType(CardActions.playCard):
            state = CardStateHelper.playCard(state, action.payload);
            break;
        case getType(CardActions.playBooster):
            state.UIState = hidePopup(
                state.UIState,
                state.UIState.popupID,
                null
            );
            state = CardStateHelper.playBooster(state, action.payload);
            break;
    }

    return {
        ...state,
        levelState: {
            ...state.levelState,

            // TODO: Get rid of this - should no longer be necessary now that IGameState is used.
            score:
                state.levelState.score + state.levelState.cardsState.turnScore,
        },
    };
};
